







































































































































































import { defineComponent, ref, Ref, onMounted, computed } from '@vue/composition-api'

// components
import { PageHeader } from '@/components'
import { DatePicker, Input, Select2 } from '@/components/general'
import { WorkDescriptionsTable, TaskSheetTable } from '@/components/piecework'
import { SwitchToggle } from '@/components/form'
import { TableTask, ModalAddSupportStaff } from '@/components/taskSheet'

// services
import { HeadquarterService, WorkDescriptionService, EmployeeService, HolidayService, OtherConfigService, AreaService } from '@/services/config'
import { PieceworkService } from '@/services/piecework'
import { AssistanceService } from '@/services/assistance'

// models
import { PieceWorkGenerate, PieceworkItemsInput } from '@/models/piecework'
import { AssistanceModel } from '@/models/assistance'
import { HeadquarterInterface, WorkDescriptionModel, IEmployee, OtherConfigModel } from '@/models/config'
import { EmployeeWithTime, TaskSheet, TaskSheetModel, WorkShifTTask } from '@/models/taskSheet'

// utils
import { alerts, formatAmount, loading, dateLibs, msToHours, subtractTime } from '@/utils'
import { getTotalHoursPiecework, getTotalWorkDescriptions, getTotalWorking } from '@/utils/piecework'
import { isWorkingInDate } from '@/utils/employee'
import { createItemToTaskSheet } from '@/utils/taskSheet'

// constants
import { WORK_TYPE_LABORER, ABSENT, TOPE_SALARIO } from '@/constants'
import PermissionControlService from '@/services/dailyControl/PermissionControlService'
import { PermissionControlModel } from '@/models/dailyControl'

export default defineComponent({
  name: 'GeneratePieceworkForm',
  components: {
    PageHeader,
    DatePicker,
    Input,
    WorkDescriptionsTable,
    TaskSheetTable,
    Select2,
    SwitchToggle,
    TableTask,
    ModalAddSupportStaff
  },
  setup (props, { root: { $router, $route } }) {
    const isLoaded = ref(false)
    const title = ref('Destajo Grupal')
    const idEdit: Ref<number|null> = ref(null)
    const breadcrumbs = [
      {
        text: 'Dashboard'
      },
      {
        text: 'Destajo Grupal',
        to: { name: 'piecework' }
      },
      {
        text: 'Ver/Generar',
        active: true
      }
    ]

    const configSalaryCap: Ref<OtherConfigModel> = ref({
      id: 0,
      name: '',
      is_active: true,
      value: 0
    })

    const isHoliday = ref(false)
    const allWorkDescriptions: Ref<WorkDescriptionModel[]> = ref([])
    const allTaskSheets: Ref<TaskSheetModel[]> = ref([])
    const headquarters: Ref<HeadquarterInterface[]> = ref([])
    const areas: Ref<AreaModel[]> = ref([])
    const employees: Ref<IEmployee[]> = ref([])
    const taskSheet: Ref<TaskSheet> = ref({
      items: [],
      timeTotal: 0,
      timeExtraTotal25: 0,
      timeExtraTotal35: 0,
      timeNocturnalTotal: 0,
      timenNocturnalTotal25: 0,
      timenNocturnalTotal35: 0
    })

    const piecework: Ref<PieceWorkGenerate> = ref({
      headquarter_id: null,
      area_id: null,
      date: null,
      is_wage: false,
      salary_cap: 34.1,
      workdescriptions_total: 0,
      workdescriptions: [],
      items: []
    })

    const totalHours = ref(0)

    const calculateTotalWorkDescriptions = () => {
      const total = getTotalWorkDescriptions(piecework.value.workdescriptions)
      piecework.value.workdescriptions_total = total
      return total
    }

    const setWorkDescriptions = async () => {
      piecework.value.workdescriptions = allWorkDescriptions.value.map(workD => {
        return {
          work_description_id: workD.id,
          total: 0,
          price: workD.price,
          amount_total: 0
        }
      })
      piecework.value.workdescriptions_total = calculateTotalWorkDescriptions()
    }

    const getWorkShiftInfo = (employee: IEmployee): {workShifTask: WorkShifTTask; timeLunch: number} => {
      const workShift = employee.assignment.work_shift
      let timeLunch = 0
      let workShifTask: WorkShifTTask = {
        workShiftId: 0,
        isCumulative: false,
        isNocturnal: false,
        checkin_time: '',
        checkout_time: '',
        lunch_time_entry: '',
        lunch_time_ends: ''
      }
      if (workShift) {
        timeLunch = msToHours(subtractTime(workShift.lunch_time_entry, workShift.lunch_time_ends))
        workShifTask = {
          workShiftId: Number(workShift.id),
          isCumulative: workShift.is_cumulative,
          isNocturnal: workShift.is_nocturnal,
          checkin_time: workShift.checkin_time,
          checkout_time: workShift.checkout_time,
          lunch_time_entry: workShift.lunch_time_entry,
          lunch_time_ends: workShift.lunch_time_ends
        }
      }
      return {
        workShifTask,
        timeLunch
      }
    }

    const createItemPieceWork = async (employee: IEmployee) => {
       const permisssionControl = await PermissionControlService.getAll({
          dateStart: piecework.value.date,
          dateEnd: piecework.value.date,
          employee: employee.id,
          reason: null
        })
        const assistanceEmployee = await AssistanceService.getAll({
          employeeId: employee.id,
          dateStart: piecework.value.date,
          dateEnd: piecework.value.date,
          headquartersId: null,
          areaId: null,
          subareaId: null
        })

        const baseSalary = Number(employee.finance.base_salary)
        const timeIn = assistanceEmployee.length > 0
                      ? dateLibs.getOnlyHourAndMinute(assistanceEmployee[0].checkin_time)
                      : (
                        employee.assignment.fixed_dialing
                        ? employee.assignment.work_shift.checkin_time
                        : ''
                      )
        const timeOut = assistanceEmployee.length > 0
                      ? dateLibs.getOnlyHourAndMinute(assistanceEmployee[0].checkout_time)
                      : (
                        employee.assignment.fixed_dialing
                        ? employee.assignment.work_shift.checkout_time
                        : ''
                      )
        const { workShifTask, timeLunch } = getWorkShiftInfo(employee)
        const item: PieceworkItemsInput = {
          employee_id: employee.id,
          task_id: null,
          task_item_id: null,
          time_in_device: '',
          time_out_device: '',
          time_in: timeIn,
          time_out: timeOut,
          total_hours: 0,
          participation: 0,
          amount_piecework: 0,
          daily: Number(formatAmount(baseSalary / 30)),
          regularization: 0,
          amount_to_pay: 0,
          time_total_extra_day_25: 0,
          time_total_extra_day_35: 0,
          time_total_nocturnal: 0,
          time_total_extra_nocturnal_25: 0,
          time_total_extra_nocturnal_35: 0,
          condition: ABSENT,
          work_type: WORK_TYPE_LABORER,
          observations: '',
          is_support: false,
          lunch: permisssionControl.length > 0 || (!timeIn || !timeOut) ? false : employee.assignment.lunch,
          lunch_rate_id: employee.assignment.lunch_rate_id,
          ajeno: false,
          amount_lunch: 1,
          work_modality: 'D',
          price_lunch: employee.assignment.lunch_rate?.price ?? 0,
          permission_controls: permisssionControl.map(permission => {
            return {
              permission_control_id: permission.id,
              reason_id: permission.reason_id,
              employee_id: employee.id,
              date_end: permission.date_end,
              date_start: permission.date_start,
              observations: permission.observations
            }
          }),
          work_shift_id: workShifTask.workShiftId,
          checkin_time: workShifTask.checkin_time,
          checkout_time: workShifTask.checkout_time,
          lunch_time_entry: workShifTask.lunch_time_entry,
          lunch_time_ends: workShifTask.lunch_time_ends,
          is_cumulative: workShifTask.isCumulative,
          is_nocturnal: workShifTask.isNocturnal,
          time_lunch: timeLunch
        }
        item.total_hours = getTotalWorking(item)
        return {
          item,
          assistanceEmployee,
          permisssionControl
        }
    }

    const addItemToTaskSheet = (employee: IEmployee, assistanceEmployee: AssistanceModel[], permisssionControl: PermissionControlModel[]) => {
      const employeeWithTime: EmployeeWithTime = {
        employee: employee,
        timeInDevice: assistanceEmployee.length > 0 ? dateLibs.getOnlyHourAndMinute(assistanceEmployee[0].checkin_time) : '',
        timeOutDevice: assistanceEmployee.length > 0 ? dateLibs.getOnlyHourAndMinute(assistanceEmployee[0].checkout_time) : '',
        timeCumulative: 0,
        dailyControls: [],
        permisssionControl: [...permisssionControl]
      }
      const itemTaskSheet = createItemToTaskSheet(employeeWithTime, WORK_TYPE_LABORER)
      return itemTaskSheet
    }

    const cratePiecework = async () => {
      taskSheet.value.items = []
      piecework.value.salary_cap = Number(configSalaryCap.value.value)
      piecework.value.items = []

      for (let i = 0; i < employees.value.length; i++) {
        const employee = employees.value[i]
        const { item, assistanceEmployee, permisssionControl } = await createItemPieceWork(employee)
        if (piecework.value.is_wage) {
          const itemTaskSheet = addItemToTaskSheet(employee, assistanceEmployee, permisssionControl)
          taskSheet.value.items.push(itemTaskSheet)
        }
        piecework.value.items.push(item)
      }
      loading('hide')
    }

    const headquartersOp = computed(() => {
      return headquarters.value.map(h => {
        return {
          text: h.name,
          value: h.id
        }
      })
    })

    const areasOp = computed(() => {
      return areas.value.map(a => ({
        text: a.name,
        value: a.id
      }))
    })

    const loadAreas = async () => {
      if (piecework.value.headquarter_id) {
        loading('show')
        try {
          areas.value = await AreaService.getAllActivate()
        } catch (error) {
          console.error('Error al cargar las áreas:', error)
          alerts.error('Error al cargar las áreas')
        } finally {
          loading('hide')
        }
      } else {
        areas.value = []
      }
      piecework.value.area_id = null
    }

    const changeJornalType = () => {
      isLoaded.value = false
      employees.value = []
      allTaskSheets.value = []
      taskSheet.value = {
        items: [],
        timeTotal: 0,
        timeExtraTotal25: 0,
        timeExtraTotal35: 0,
        timeNocturnalTotal: 0,
        timenNocturnalTotal25: 0,
        timenNocturnalTotal35: 0
      }
      piecework.value = {
        date: piecework.value.date,
        is_wage: piecework.value.is_wage,
        headquarter_id: piecework.value.headquarter_id,
        salary_cap: 34.1,
        workdescriptions: [],
        workdescriptions_total: 0,
        items: []
      }
      setWorkDescriptions()
    }

    const save = () => {
      if (piecework.value.is_wage) {
        piecework.value.items = taskSheet.value.items.map(item => {
          return {
            employee_id: item.employeeId,
            task_id: null,
            task_item_id: null,
            time_in_device: item.timeInDevice,
            time_out_device: item.timeOutDevice,
            time_in: item.timeIn,
            time_out: item.timeOut,
            total_hours: item.timeWorkingTotal,
            participation: 0,
            amount_piecework: 0,
            daily: 0,
            regularization: 0,
            amount_to_pay: 0,
            time_total_extra_day_25: item.timeExtra25,
            time_total_extra_day_35: item.timeExtra35,
            time_total_nocturnal: item.timeTotalN,
            time_total_extra_nocturnal_25: item.timeExtra25N,
            time_total_extra_nocturnal_35: item.timeExtra35N,
            condition: item.condition,
            work_type: WORK_TYPE_LABORER,
            observations: item.observations,
            is_support: item.isSupport,
            lunch: item.lunch,
            ajeno: item.ajeno,
            lunch_rate_id: item.lunch_rate_id,
            amount_lunch: item.amount_lunch,
            work_modality: 'D',
            price_lunch: item.price_lunch,
            permission_controls: item.permissions.map(permission => {
              return {
                permission_control_id: permission.id,
                reason_id: permission.reason_id,
                employee_id: item.employeeId,
                date_end: permission.date_end,
                date_start: permission.date_start,
                observations: permission.observations
              }
            }),
            work_shift_id: item.workShift.workShiftId,
            checkin_time: item.workShift.checkin_time,
            checkout_time: item.workShift.checkout_time,
            lunch_time_entry: item.workShift.lunch_time_entry,
            lunch_time_ends: item.workShift.lunch_time_ends,
            is_cumulative: item.workShift.isCumulative,
            is_nocturnal: item.workShift.isNocturnal,
            time_lunch: item.timeLunch
          }
        })
      }
      loading('show')
      let request
      if (!idEdit.value) {
        request = PieceworkService.create(piecework.value)
      } else {
        request = PieceworkService.update(idEdit.value, piecework.value)
      }
      request.then(() => {
        alerts.success()
        $router.push({
          name: 'piecework'
        })
      }).catch(() => {
        alerts.error()
      }).finally(() => {
        loading('hide')
      })
    }

    const getPieceworkById = async () => {
      if (idEdit.value) {
        loading('show')
        try {
          const pieceworkSelect = await PieceworkService.getById(idEdit.value)
          totalHours.value = getTotalHoursPiecework(pieceworkSelect.piecework_items)
          piecework.value = {
            date: pieceworkSelect.date,
            headquarter_id: pieceworkSelect.headquarter_id,
            is_wage: pieceworkSelect.is_wage,
            salary_cap: pieceworkSelect.salary_cap,
            workdescriptions_total: pieceworkSelect.workdescriptions_total,
            workdescriptions: pieceworkSelect.piecework_work_descriptions.map(work => {
              return {
                work_description_id: work.work_description_id,
                total: work.total,
                price: work.price,
                amount_total: work.amount_total
              }
            }),
            items: pieceworkSelect.piecework_items.map(item => {
              employees.value.push(item.employee)
              if (pieceworkSelect.is_wage) {
                const employeeWithTime: EmployeeWithTime = {
                  employee: item.employee,
                  timeInDevice: '',
                  timeOutDevice: '',
                  timeCumulative: 0,
                  dailyControls: [],
                  permisssionControl: item.permission_control_piecework.map(permission => {
                    return {
                      id: permission.permission_control_id,
                      employee_id: permission.employee_id,
                      employee: permission.employee,
                      reason_id: permission.reason_id,
                      reason: permission.reason,
                      date_start: permission.date_start,
                      date_end: permission.date_end,
                      observations: permission.observations,
                      created_at: new Date(),
                      updated_at: new Date(),
                      deleted_at: new Date()
                    }
                  })
                }
                const itemTaskSheet = createItemToTaskSheet(employeeWithTime, WORK_TYPE_LABORER, item.is_support)
                itemTaskSheet.timeIn = item.time_in
                itemTaskSheet.timeOut = item.time_out
                itemTaskSheet.observations = item.observations
                itemTaskSheet.lunch = item.lunch
                itemTaskSheet.lunch_rate_id = item.lunch_rate_id
                itemTaskSheet.lunch_rate = item.lunch_rate
                taskSheet.value.items.push(itemTaskSheet)
              }
              return {
                employee_id: item.employee_id,
                task_id: item.task_id,
                task_item_id: item.task_item_id,
                time_in_device: item.time_in_device,
                time_out_device: item.time_out_device,
                time_in: item.time_in,
                time_out: item.time_out,
                total_hours: item.total_hours,
                participation: item.participation,
                amount_piecework: item.amount_piecework,
                daily: Number(formatAmount(item.daily)),
                regularization: item.regularization,
                amount_to_pay: item.amount_to_pay,
                time_total_extra_day_25: item.time_total_extra_day_25,
                time_total_extra_day_35: item.time_total_extra_day_35,
                time_total_nocturnal: item.time_total_nocturnal,
                time_total_extra_nocturnal_25: item.time_total_extra_nocturnal_25,
                time_total_extra_nocturnal_35: item.time_total_extra_nocturnal_35,
                condition: item.condition,
                work_type: item.work_type,
                observations: item.observations,
                is_support: item.is_support,
                lunch: item.lunch,
                ajeno: item.ajeno,
                lunch_rate_id: item.lunch_rate_id,
                amount_lunch: item.amount_lunch,
                work_modality: item.work_modality,
                price_lunch: item.price_lunch,
                work_shift_id: item.work_shift_id,
                checkin_time: item.checkin_time,
                checkout_time: item.checkout_time,
                lunch_time_entry: item.lunch_time_entry,
                lunch_time_ends: item.lunch_time_ends,
                is_cumulative: item.is_cumulative,
                is_nocturnal: item.is_nocturnal,
                time_lunch: item.time_lunch,
                permission_controls: item.permission_control_piecework.map(permission => {
                  return {
                    permission_control_id: permission.permission_control_id,
                    reason_id: permission.reason_id,
                    employee_id: permission.employee_id,
                    date_end: permission.date_end,
                    date_start: permission.date_start,
                    observations: permission.observations
                  }
                })
              }
            })
          }
          isLoaded.value = true
        } catch (e) {
          alerts.error()
          $router.push({
            name: 'piecework'
          })
        }
        loading('hide')
      }
    }

    const generate = async () => {
      isLoaded.value = false
      if (!piecework.value.date) {
        return alerts.error('Debe selecccionar una fecha para continuar.!')
      }
      if (!piecework.value.headquarter_id) {
        return alerts.error('Debe seleccionar una sede.!')
      }
      if (!piecework.value.area_id) {
        return alerts.error('Debe seleccionar un área.!')
      }
      const exists = await PieceworkService.exists(
        piecework.value.date,
        Number(piecework.value.headquarter_id),
        Number(piecework.value.area_id),
        piecework.value.is_wage
      )
      if (exists.exists) {
        idEdit.value = exists.id
        getPieceworkById()
      } else {
        loading('show')
        employees.value = []
        allTaskSheets.value = []
        taskSheet.value = {
          items: [],
          timeTotal: 0,
          timeExtraTotal25: 0,
          timeExtraTotal35: 0,
          timeNocturnalTotal: 0,
          timenNocturnalTotal25: 0,
          timenNocturnalTotal35: 0
        }
        const allEmployees = await EmployeeService.getAll({
          name: '',
          position: null,
          workCategory: null,
          typeContract: null,
          headquarters: Number(piecework.value.headquarter_id),
          area: Number(piecework.value.area_id),
          subArea: null,
          workType: null,
          status: true
        })
        employees.value = allEmployees.filter(e => isWorkingInDate(e, String(piecework.value.date))).filter(e => e.assignment.sub_area.is_group_piecework && e.assignment.sub_area.is_active)
        cratePiecework()
      }
      isLoaded.value = true
    }

    const showModalAddSupportStaff = ref(false)
    const addSupportStaff = (employee: IEmployee) => {
      const existEmployee = employees.value.find(e => e.id === employee.id)
      if (!existEmployee) {
        employees.value.push(employee)
      }
      showModalAddSupportStaff.value = false
      if (!piecework.value.is_wage) {
        const baseSalary = Number(employee.finance.base_salary)
        const { workShifTask, timeLunch } = getWorkShiftInfo(employee)
        const item: PieceworkItemsInput = {
          employee_id: employee.id,
          task_id: null,
          task_item_id: null,
          time_in_device: '',
          time_out_device: '',
          time_in: '',
          time_out: '',
          total_hours: 0,
          participation: 0,
          amount_piecework: 0,
          daily: baseSalary / 30,
          regularization: 0,
          amount_to_pay: 0,
          time_total_extra_day_25: 0,
          time_total_extra_day_35: 0,
          time_total_nocturnal: 0,
          time_total_extra_nocturnal_25: 0,
          time_total_extra_nocturnal_35: 0,
          condition: ABSENT,
          work_type: WORK_TYPE_LABORER,
          observations: '',
          is_support: true,
          lunch: employee.assignment.lunch,
          ajeno: false,
          lunch_rate_id: employee.assignment.lunch_rate_id,
          amount_lunch: 1,
          work_modality: 'D',
          price_lunch: employee.assignment.lunch_rate?.price ?? 0,
          permission_controls: [],
          work_shift_id: workShifTask.workShiftId,
          checkin_time: workShifTask.checkin_time,
          checkout_time: workShifTask.checkout_time,
          lunch_time_entry: workShifTask.lunch_time_entry,
          lunch_time_ends: workShifTask.lunch_time_ends,
          is_cumulative: workShifTask.isCumulative,
          is_nocturnal: workShifTask.isNocturnal,
          time_lunch: timeLunch
        }
        piecework.value.items.push(item)
      } else {
        const item: EmployeeWithTime = {
          employee: employee,
          timeInDevice: '',
          timeOutDevice: '',
          timeCumulative: 0,
          dailyControls: [],
          permisssionControl: []
        }
        taskSheet.value.items.push(createItemToTaskSheet(item, WORK_TYPE_LABORER, true))
      }
    }

    const employeeIdExceptForSupport = computed(() => {
      return [...employees.value.map(item => {
        return Number(item.id)
      }),
      ...taskSheet.value.items.map(item => {
        return Number(item.employeeId)
      })]
    })

    const deleteItemFromEmployeeList = (employeeId: number) => {
      const indexEmployee = employees.value.findIndex(employee => Number(employee.id) === Number(employeeId))
      employees.value.splice(indexEmployee, 1)
    }

    const deleteItemFromTaskSheetByEmployeeId = (employeeId: number) => {
      deleteItemFromEmployeeList(employeeId)
      const indexInTaskSheet = taskSheet.value.items.findIndex(item => Number(item.employeeId) === Number(employeeId))
      taskSheet.value.items.splice(indexInTaskSheet, 1)
    }

    const updateRecord = async (itemOld: PieceworkItemsInput, index: number) => {
      const employee = employees.value.find(e => e.id === itemOld.employee_id)
      if (employee) {
        loading('show')
        const getEmployeeData = await EmployeeService.getByID(employee.id)
        // @ts-ignore
        const { item } = await createItemPieceWork(getEmployeeData)
        // piecework.value.items[index] = { ...item }
        piecework.value.items.splice(index, 1)
        setTimeout(() => {
          piecework.value.items.splice(index, 0, { ...item })
          loading('hide')
        }, 1000)
      }
    }

    const handleChangeDate = async () => {
      const holidays = await HolidayService.getActivated(piecework.value.date)
      if (holidays.length > 0) {
        isHoliday.value = true
      } else {
        isHoliday.value = false
      }
    }

    onMounted(async () => {
      headquarters.value = await HeadquarterService.getAllActivate()
      areas.value = await AreaService.getAllActivate()
      allWorkDescriptions.value = await WorkDescriptionService.getActivatedAndOnlyPiecework()
      configSalaryCap.value = await OtherConfigService.getByID(TOPE_SALARIO)
      setWorkDescriptions()
      if ($route.params?.id) {
        idEdit.value = Number($route.params.id)
        getPieceworkById()
      }
    })

    return {
      title,
      breadcrumbs,
      piecework,
      generate,
      isLoaded,
      allTaskSheets,
      calculateTotalWorkDescriptions,
      headquartersOp,
      areasOp,
      loadAreas,
      changeJornalType,
      WORK_TYPE_LABORER,
      taskSheet,
      employees,
      allWorkDescriptions,
      totalHours,
      save,
      idEdit,
      showModalAddSupportStaff,
      addSupportStaff,
      employeeIdExceptForSupport,
      deleteItemFromTaskSheetByEmployeeId,
      deleteItemFromEmployeeList,
      updateRecord,
      handleChangeDate,
      isHoliday,
      configSalaryCap
    }
  }
})
